import styled, { css } from 'styled-components';

export const DataColumn = styled.div`
  ${({ card }) => {
    if (card) {
      return css`
        border: thin solid #eee;
        box-shadow: 1px 8px 40px rgba(0, 0, 0, 0.15);
        padding: 16px;
      `;
    }
  }};
`;
